<script>
    import BaseHistoryChart from '../../common/BaseHistoryChart.svelte';

    const loanFeeDatasets = [
        {
            label: 'Lån',
            dataKey: 'total_amount_of_loans',
            borderColor: '#5a5a5b',
            pointBackgroundColor: '#5a5a5b',
            fill: true,
            gradientColors: { start: 'rgba(90, 90, 91, 0.4)', stop: 'rgba(90, 90, 91, 0.05)' },
            yAxisID: 'y',
            tooltipSuffix: '' // No extra suffix, label includes (tkr)
        },
        {
            label: 'Avgiftsintäkter',
            dataKey: 'annual_fee_income',
            borderColor: '#e7e7e4',
            pointBackgroundColor: '#e7e7e4',
            fill: false, // This line is not filled
            yAxisID: 'y1',
            tooltipSuffix: '' // No extra suffix, label includes (tkr)
        }
    ];

    const loanFeeYAxes = [
        {
            id: 'y',
            title: 'Lån (tkr)',
            position: 'left',
        },
        {
            id: 'y1',
            title: 'Avgiftsintäkter (tkr)',
            position: 'right',
            grid: { drawOnChartArea: false } // Specific grid configuration for this axis
        }
    ];
</script>

<BaseHistoryChart
    headerTitle="Lån och Avgifter"
    datasetsConfig={loanFeeDatasets}
    yAxesConfig={loanFeeYAxes}
    xAxisTitleText="År"
/>
